export default {

    setItem: (key, value) => {
        if (typeof (sessionStorage) !== 'undefined') {
            sessionStorage.setItem(key, value)
            return true
        }
        return false
    },

    removeItem: (key) => {
        if (typeof (sessionStorage) !== 'undefined') {
            sessionStorage.removeItem(key)
            return true
        }
        return false
    },

    getItem: (key) => {
        let item = null
        if (typeof (sessionStorage) !== 'undefined') {
            item = sessionStorage.getItem(key)
        }
        return item
    },

    clear: () => {
        if (typeof (sessionStorage) !== 'undefined') {
            sessionStorage.clear()
        }
    }


}
